import type { FaireThemeEntity } from "../../entity_types/theme";

export const premium_counter_side_cravings: FaireThemeEntity = {
  token: "premium-counter-side-cravings",
  type: "theme",
  name: "Premium Counter-Side Cravings",
  description: "Elevate your snack selection with kettle-cooked chips and artisanal treats. These high-quality, gluten-free options are the perfect impulse buy for customers browsing your books and gifts.",
  teaser: "Shiva's Gift Shop has a high interest in chips and snacks, and frequently looks for product signals like organic, non-GMO, and gluten-free, which these gourmet snacks provide.",
  detail: "The additional_context includes a recent order for a Kettle Potato Chips Variety Pack from Deep River Snacks, which is certified gluten-free and made with no artificial flavors.",
  bgColor: "#D4E8E8",
  tileBgColor: "#3d6b6b",
  exactProducts: true,
  retailerToken: "r_31m33roqxk",
  productTokens: [
    "p_5e8pynduyx",
    "p_5j9t7pbe4d",
    "p_wjzshhvj4m",
    "p_satwcknq88",
    "p_2t3yx3mukt",
    "p_6bn79ed9mb",
    "p_h4a9xgxvmb",
    "p_xpfjquabqb",
    "p_estee38kn7",
    "p_crzctns3aw",
    "p_46qef7w7q8",
    "p_a5bvgwy2zx",
    "p_paayf33698",
    "p_r29ghyd5er",
    "p_8gjmt5sjye",
    "p_x4nadf34ke",
    "p_eanpefba4j",
    "p_7rw7e9s2ce",
    "p_gv3w4cnez5",
    "p_tzgyvxtycp",
    "p_wc8g5wd5jv",
    "p_r3zvv8xbeu",
    "p_fqggnmpyca",
    "p_mc6ysyjy8c",
    "p_er2m9n5gwr",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-26T00:00:00Z",
    importedBy: "manual-v3-import",
  },
};
